import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

interface LocationTypeQuestionBubbleProps {
  displayName?: string | undefined;
}

const LocationTypeQuestionBubble: React.FC<LocationTypeQuestionBubbleProps> = (
  props: LocationTypeQuestionBubbleProps,
) => {
  const displayName = props.displayName?.toLowerCase();

  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">
            {displayName
              ? `What type of location is the ${displayName} address?`
              : `What type of location is this address?`}
          </T>
          <T size="xs" color="secondary">
            Make sure you enter the correct location type, as it affects the
            quote.
          </T>
          <T size="xs" color="secondary">
            {displayName
              ? `If at ${displayName}, the location type is different than the type you specified, you may incur an additional charge.`
              : `If when the carrier arrives at the location, the location type is different than the type you specified, you may incur an additional charge.`}
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/location-types"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
};
export default LocationTypeQuestionBubble;
